import React, { useState } from 'react';
import axios from 'axios';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import {
  Box,
  Heading,
  FormControl,
  FormLabel,
  Input,
  Button,
  Text,
  Link,
  VStack
} from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

const LoginAdmin = () => {
  const { t } = useTranslation();
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

      // Generar o recuperar custom_device_id
      let customDeviceId = localStorage.getItem('custom_device_id');
      if (!customDeviceId) {
        customDeviceId = `device-${Date.now()}-${Math.random().toString(36).substring(2, 15)}`;
        localStorage.setItem('custom_device_id', customDeviceId);
      }

      // Construir device_info con la información disponible en el navegador
      const device_info = {
        user_agent: navigator.userAgent || null,
        accept_language: navigator.language || null,
        app_version: navigator.appVersion || null,
        platform: navigator.platform || null,
        vendor: navigator.vendor || null,
        ip_address: null,
        ip_address_forwarded: null,
        origin: window.location.origin,
        referer: document.referrer || null,
        connection_type: navigator.connection ? navigator.connection.effectiveType : null,
        accept_encoding: null,
        x_requested_with: "XMLHttpRequest",
        custom_device_id: customDeviceId
      };

      const response = await axios.post(
        `${API_BASE_URL}/api/sesiones/login-admin/`,
        { email, password, device_info }
      );

      const { access_token, user_id, user_type, email: userEmail, nombre } = response.data;

      localStorage.setItem('auth-token', access_token);
      localStorage.setItem('user_id', user_id);
      localStorage.setItem('user_type', user_type);
      localStorage.setItem('user_email', userEmail);
      localStorage.setItem('user_nombre', nombre);

      login(response.data);

      // Redirige al dashboard de admin
      navigate('/admin/');
    } catch (err) {
      setError(err.response?.data?.detail || t('login_admin_error'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box p={4}>
      <Heading as="h2" size="lg" mb={4}>
        {t('login_admin_titulo')}
      </Heading>
      <Box as="form" onSubmit={handleSubmit}>
        <VStack spacing={4} align="stretch">
          <FormControl id="email">
            <FormLabel>{t('login_admin_email')}</FormLabel>
            <Input
              type="email"
              placeholder={t('login_admin_email_placeholder')}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoFocus
            />
          </FormControl>
          <FormControl id="password">
            <FormLabel>{t('login_admin_password')}</FormLabel>
            <Input
              type="password"
              placeholder={t('login_admin_password_placeholder')}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </FormControl>
          <Button type="submit" colorScheme="blue" isLoading={loading}>
            {loading ? t('login_admin_accediendo') : t('login_admin_acceder')}
          </Button>
          {error && (
            <Text color="red.500" mt={2}>
              {error}
            </Text>
          )}
        </VStack>
      </Box>
      <Box mt={4}>
        <Link as={RouterLink} to="/" color="blue.600">
          {t('login_admin_volver')}
        </Link>
      </Box>
    </Box>
  );
};

export default LoginAdmin;